import React from "react";
import { Card } from "@/components/ui/card";

export default function KpiCard({ label, value, sub, color, testid }) {
  return (
    <Card className="p-4 bg-card border-border" data-testid={testid}>
      <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</div>
      <div className="mt-1.5 text-2xl sm:text-3xl font-extrabold tracking-tight font-mono"
        style={color ? { color } : undefined} data-testid={`${testid}-value`}>
        {value ?? "-"}
      </div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </Card>
  );
}

export function fmtNum(v) {
  if (v === null || v === undefined) return "-";
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(v);
}

export function fmtPct(v) {
  if (v === null || v === undefined) return "-";
  return `%${new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(v)}`;
}
